/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  dataStoreReference: Item<'DataStoreReference'>;
  bingMap: Item<'BingMap'>;
  localDataStore: Item<'LocalDataStore'>;
} = {
  bingMap: {
    children: [],
    itemId: 'bingMap',
    parent: 'flexItem',
    props: {
      mapType: 'canvasLight',
      icon: {
        iconName: 'charging-station',
        iconType: 'light',
      },
      latitudeAttribute: 'latitude',
      longitudeAttribute: 'longitude',
      titleAttribute: 'city',
    },
    type: 'BingMap',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'bingMapHelpAlias',
    },
    type: 'DataStoreReference',
  },
  flexItem: {
    children: ['bingMap'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'bingMapHelpAlias',
      data: 'latitude,longitude,city\n45.23,-86.43,Leland\n43.34,-94.87,Lake Mills',
      dataSource: 'BingMapHelp',
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};
